/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import React, {
  useContext,
  createContext,
  useState,
  useCallback,
  useEffect,
} from 'react';

type IData = {
  selected?: boolean;
  dsCidade?: string;
  idCidade?: any;
  idEstado?: any;
  idMarketplace?: any;
};

type ISelectedStateCityContext = {
  data: IData;
  createSelected(param: boolean): Promise<void>;
};
const SelectedStateCityContext = createContext<
  Partial<ISelectedStateCityContext>
>({});

export const SelectedStateCityProvider = ({ children }: any) => {
  const [data, setData] = useState<IData>({
    selected: false,
    dsCidade: '',
    idCidade: 0,
    idEstado: 0,
    idMarketplace: 0,
  });

  const dataUserMemory = useCallback(() => {
    return new Promise((resolve) => {
      const dataStorage = JSON.parse(
        localStorage.getItem('@mais/delivery/dataStateCity') as string,
      );
      if (dataStorage) {
        setData({
          selected: !!(
            dataStorage?.dsCidade &&
            dataStorage?.idCidade &&
            dataStorage?.idMarketplace
          ),
          dsCidade: dataStorage?.dsCidade,
          idCidade: dataStorage?.idCidade,
          idMarketplace: dataStorage?.idMarketplace,
        });
      }
      resolve(true);
    });
  }, []);

  useEffect(() => {
    (async () => {
      await dataUserMemory();
    })();
  }, []);

  const createSelected = async (param: boolean) => {
    setData((field) => {
      return {
        ...field,
        [`selected`]: param,
      };
    });
  };

  return (
    <SelectedStateCityContext.Provider
      value={{
        data,
        createSelected,
      }}
    >
      {children}
    </SelectedStateCityContext.Provider>
  );
};

export const useSelectedStateCityContext: any = () => {
  return useContext(SelectedStateCityContext);
};
